import React from 'react'

function getCoordinates(cx, cy, radius, angleDeg) {
  const angleRad = ((angleDeg - 90) * Math.PI) / 180
  return {
    x: cx + radius * Math.cos(angleRad) + 12,
    y: cy + radius * Math.sin(angleRad),
  }
}

const PieLabels = ({ data, cx, cy, radius }) => {
  const total = data.reduce((sum, d) => sum + d.value, 0)
  let currentAngle = 0

  const slices = data.map((d) => {
    const angle = (d.value / total) * 360
    const midAngle = currentAngle + angle / 2
    const isLeft = Math.cos((midAngle - 90) * (Math.PI / 180)) < 0
    const anchor = getCoordinates(cx, cy, radius - 14, midAngle)
    currentAngle += angle
    return { ...d, midAngle, isLeft, anchor }
  })

  const circleRadius = 8

  return (
    <svg
      style={{ position: 'absolute', top: 0, left: 0, pointerEvents: 'none' }}
      width="100%"
      height="100%"
    >
      {(() => {
        const leftEdgeX = cx - radius - 50
        const rightEdgeX = cx + radius + 50
        const textOffset = 12

        return slices.map((d, i) => {
          const { anchor, isLeft } = d

          const circleX = isLeft ? leftEdgeX : rightEdgeX
          const labelX = isLeft
            ? circleX - circleRadius - textOffset
            : circleX + circleRadius + textOffset
          const textAnchor = isLeft ? 'end' : 'start'

          return (
            <g key={i}>
              {/* Connector line */}
              <line
                x1={anchor.x}
                y1={anchor.y}
                x2={circleX}
                y2={anchor.y}
                stroke="#ccc"
                strokeDasharray="2,2"
              />

              {/* Color dot */}
              <circle
                cx={circleX}
                cy={anchor.y}
                r={circleRadius}
                fill={d.color}
              />

              {/* Text label */}
              <text
                x={labelX}
                y={anchor.y}
                textAnchor={textAnchor}
                alignmentBaseline="middle"
                style={{ fontSize: 18, fill: '#333', fontWeight: 600 }}
              >
                ${d.value.toLocaleString()}
                <tspan
                  x={labelX}
                  dy="1.8em"
                  style={{
                    fontSize: 14,
                    fill: '#888',
                    fontWeight: 400,
                  }}
                >
                  {d.label}
                </tspan>
              </text>
            </g>
          )
        })
      })()}
    </svg>
  )
}

export default PieLabels
